import { Input, InputProps } from 'antd';
import SvgIconSearch from '../@svg/SvgSearch';
import './index.scss';
import SvgIconClose from '../@svg/SvgClose';

const CustomSearchInput = (props: InputProps) => {
  const { ...restProps } = props;

  return (
    <Input
      prefix={<SvgIconSearch />}
      allowClear={{ clearIcon: <SvgIconClose /> }}
      {...restProps}
      placeholder={restProps?.placeholder ? restProps.placeholder : ''}
      className={`ant-custom-search-input ${restProps.className}`}
    />
  );
};

export default CustomSearchInput;
